import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icn-comments-active",
  "use": "icon-icn-comments-active-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icn-comments-active\"><path d=\"M13.5.762c.422 0 .773.152 1.055.457.304.281.457.62.457 1.02v9c0 .421-.153.784-.457 1.09a1.43 1.43 0 01-1.055.421H2.988L0 15.738v-13.5c0-.398.14-.738.422-1.02a1.488 1.488 0 011.09-.456H13.5zM2.988 6v1.512h9V6h-9zM9 9.762V8.25H2.988v1.512H9zm2.988-4.5V3.75h-9v1.512h9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol